import {
	analyticsAccess,
	analyticsAttribution,
	analyticsFilters,
	analyticsGeo,
	analyticsOverview,
	analyticsProducts,
	analyticsSessions,
} from '@/services/academy/productAnalytics.service'

const emptyPaginated = () => ({ data: [], meta: { pagination: { total: 0 } } })

export default {
	namespaced: true,
	state: {
		filters:        { products: [], platforms: [], countries: [], regions: [], currencies: [], steps: [] },
		filtersStatus:  'init',
		overview:       null,
		overviewStatus: 'init',
		geo:            {
			by_country: [], by_region: [], by_region_product: [],
			revenue_by_region: {}, price_shown_by_region: {}, amount_paid_by_region: {},
			price_shown_by_country: {}, amount_paid_by_country: {},
			price_shown_by_region_product: {}, amount_paid_by_region_product: {},
		},
		geoStatus:      'init',
		products:       { rows: [], revenue: {}, price_shown_by_currency: {}, amount_paid_by_currency: {} },
		productsStatus: 'init',
		attribution:       {
			dimension: 'utm_source', rows: [], revenue: {},
			price_shown_by_currency: {}, amount_paid_by_currency: {},
		},
		attributionStatus: 'init',
		sessions:       emptyPaginated(),
		sessionsStatus: 'init',
		access:         { ...emptyPaginated(), summary: [] },
		accessStatus:   'init',
	},
	getters: {
		getFilters:           s => s.filters,
		getFiltersStatus:     s => s.filtersStatus,
		getOverview:          s => s.overview,
		getOverviewStatus:    s => s.overviewStatus,
		getGeo:               s => s.geo,
		getGeoStatus:         s => s.geoStatus,
		getProducts:          s => s.products,
		getProductsStatus:    s => s.productsStatus,
		getAttribution:       s => s.attribution,
		getAttributionStatus: s => s.attributionStatus,
		getSessions:          s => s.sessions,
		getSessionsStatus:    s => s.sessionsStatus,
		getAccess:            s => s.access,
		getAccessStatus:      s => s.accessStatus,
	},
	mutations: {
		SET_FILTERS(s, v)            { s.filters = v },
		SET_FILTERS_STATUS(s, v)     { s.filtersStatus = v },
		SET_OVERVIEW(s, v)           { s.overview = v },
		SET_OVERVIEW_STATUS(s, v)    { s.overviewStatus = v },
		SET_GEO(s, v)                { s.geo = v },
		SET_GEO_STATUS(s, v)         { s.geoStatus = v },
		SET_PRODUCTS(s, v)           { s.products = v },
		SET_PRODUCTS_STATUS(s, v)    { s.productsStatus = v },
		SET_ATTRIBUTION(s, v)        { s.attribution = v },
		SET_ATTRIBUTION_STATUS(s, v) { s.attributionStatus = v },
		SET_SESSIONS(s, v)           { s.sessions = v },
		SET_SESSIONS_STATUS(s, v)    { s.sessionsStatus = v },
		SET_ACCESS(s, v)             { s.access = v },
		SET_ACCESS_STATUS(s, v)      { s.accessStatus = v },
	},
	actions: {
		async fetchFilters({ commit }) {
			commit('SET_FILTERS_STATUS', 'pending')
			try {
				const { data } = await analyticsFilters()
				commit('SET_FILTERS', data.data)
				commit('SET_FILTERS_STATUS', 'init')
			} catch { commit('SET_FILTERS_STATUS', 'error') }
		},
		async fetchOverview({ commit }, params) {
			commit('SET_OVERVIEW_STATUS', 'pending')
			try {
				const { data } = await analyticsOverview(params)
				commit('SET_OVERVIEW', data.data)
				commit('SET_OVERVIEW_STATUS', 'init')
			} catch { commit('SET_OVERVIEW_STATUS', 'error') }
		},
		async fetchGeo({ commit }, params) {
			commit('SET_GEO_STATUS', 'pending')
			try {
				const { data } = await analyticsGeo(params)
				commit('SET_GEO', data.data)
				commit('SET_GEO_STATUS', 'init')
			} catch { commit('SET_GEO_STATUS', 'error') }
		},
		async fetchProducts({ commit }, params) {
			commit('SET_PRODUCTS_STATUS', 'pending')
			try {
				const { data } = await analyticsProducts(params)
				commit('SET_PRODUCTS', data.data)
				commit('SET_PRODUCTS_STATUS', 'init')
			} catch { commit('SET_PRODUCTS_STATUS', 'error') }
		},
		async fetchAttribution({ commit }, params) {
			commit('SET_ATTRIBUTION_STATUS', 'pending')
			try {
				const { data } = await analyticsAttribution(params)
				commit('SET_ATTRIBUTION', data.data)
				commit('SET_ATTRIBUTION_STATUS', 'init')
			} catch { commit('SET_ATTRIBUTION_STATUS', 'error') }
		},
		async fetchSessions({ commit }, params) {
			commit('SET_SESSIONS_STATUS', 'pending')
			try {
				const { data } = await analyticsSessions(params)
				commit('SET_SESSIONS', data)
				commit('SET_SESSIONS_STATUS', 'init')
			} catch { commit('SET_SESSIONS_STATUS', 'error') }
		},
		async fetchAccess({ commit }, params) {
			commit('SET_ACCESS_STATUS', 'pending')
			try {
				const { data } = await analyticsAccess(params)
				commit('SET_ACCESS', data)
				commit('SET_ACCESS_STATUS', 'init')
			} catch { commit('SET_ACCESS_STATUS', 'error') }
		},
	},
}
